  <script>
  import { onMount } from 'svelte'
  import Page from '@components/page.svelte'
  import FilterBar from '@components/table/filter-bar.svelte'
  import Pagination from '@components/table/pagination.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import GridView from '@components/videos/grid-view.svelte'
  import { usePageParam } from '@hooks/use-page-param.svelte'
  import { CirclePlay, ClockArrowDown, ClockArrowUp, ArrowUpAZ, ArrowDownZA, Tag as TagIcon, Settings, Lock, Unlock, CheckCheck } from 'lucide-svelte'
  import { page } from '@inertiajs/svelte'

  let { videos = [], pagination, tags = [] } = $props()

  let pageProps = {
    pageTitle: "Videos",
    title: "Video Library",
    subtitle: "Our extensive catalogue of Wellbeing Sessions and Webinars",
    Icon: CirclePlay,
    adminActions: [
      { text: "Manage", path: "/admin/videos", icon: Settings }
    ]
  }

  let user = $page.props.user

  let access = usePageParam({ key: "access", defaultValue: "all", items: [
    { value: "free", label: "Free videos", icon: Unlock },
    { value: "premium", label: "Premium videos", icon: Lock },
    { value: "all", label: "All videos", icon: CheckCheck },
  ] })

  let tagOptions = $derived.by(() => {
    const emptyOption = { value: "", label: "All tags", icon: TagIcon }
    let options = tags.filter(tag => tag.count > 0)
    options = options.map(tag => ({ value: tag.id, label: `${tag.name} (${tag.count})`, icon: TagIcon }))
    return [emptyOption, ...options]
  })

  let sort = usePageParam({ key: "sort", defaultValue: "az", items: [
    { value: "newest", label: "Most recent", icon: ClockArrowDown },
    { value: "oldest", label: "Oldest", icon: ClockArrowUp },
    { value: "az", label: "Alphabetical A-Z", icon: ArrowUpAZ },
    { value: "za", label: "Alphabetical Z-A", icon: ArrowDownZA }
  ]})

  let tag = usePageParam({ key: "tag", items: tagOptions })

  let hoverEffect = $state(false)

  function setTagFilter(tagItem) {
    tag.setValue(tagItem.value)
    hoverEffect = false
  }

  // The tag dropdown has the mouse directly over a video and we don't want the hover effect to show immediately
  onMount(() => {
    setTimeout(() => hoverEffect = true, 1000)
  })

</script>

<Page {...pageProps}>

  <FilterBar {pagination} paginationProps={{ summary: true, terms: ["video", "videos"] }}>
    {#snippet filters()}

      <!-- Sort -->
      <Dropdown buttonProps={{ text: sort.label, Icon: sort.icon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
        {#snippet contents(item)}
          {#each sort.items as sortItem (sortItem.value)}
            {@render item({ text: sortItem.label, icon: sortItem.icon, onSelect: () => sort.setValue(sortItem.value) })}
          {/each}
        {/snippet}
      </Dropdown>

      <!-- Tag filter -->
      <Dropdown buttonProps={{ text: tag.label, Icon: TagIcon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
        {#snippet contents(item)}
          {#each tag.items as tagItem (tagItem.value)}
            {@render item({ text: tagItem.label, icon: tagItem.icon, onSelect: () => setTagFilter(tagItem) })}
          {/each}
        {/snippet}
      </Dropdown>

      <!-- Access filter (only show for non-premium users) -->
      {#if !user?.has_active_membership}
        <Dropdown buttonProps={{ text: access.label, Icon: access.icon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
          {#snippet contents(item)}
            {#each access.items as accessItem (accessItem.value)}
              {@render item({ text: accessItem.label, icon: accessItem.icon, onSelect: () => access.setValue(accessItem.value) })}
            {/each}
          {/snippet}
        </Dropdown>
      {/if}
    {/snippet}
  </FilterBar>

  <GridView {videos} {hoverEffect} />

  <Pagination {pagination} paginationProps={{ summary: true, terms: ["video", "videos"] }} />

</Page>
